import { AbstractControl, Validators } from '@angular/forms';
import { CheckCategoryEnum } from '@qaroni-app/check/types/check-category.enum';
import { QaroniBaseFormsDirective } from '@qaroni-core/directives/qaroni-base-forms/qaroni-base-forms.directive';
import { format, parseISO } from 'date-fns';

export class CheckWidgetForm extends QaroniBaseFormsDirective {
  private skeleton = {
    type: ['WEB', Validators.required],
    startDate: ['', Validators.required],
    category: [CheckCategoryEnum.WORK, Validators.required],
  };

  public form = this.fb.group(this.skeleton);

  get startDate(): AbstractControl {
    return this.form.get('startDate');
  }

  get category(): AbstractControl {
    return this.form.get('category');
  }

  public prepareDataToSend(): void {
    const now = new Date().toISOString().slice(0, -1);
    const date = format(parseISO(now), 'yyyy-MM-dd HH:mm:ss');
    this.startDate.setValue(date);
  }
}
